(function () {
    'use strict';
    angular
        .module('app')
        .factory('notificationListsService', notificationListsService);
    notificationListsService.$inject = ['$http', '$q', '$localStorage', '$timeout'];
    function notificationListsService($http, $q, $localStorage, $timeout) {
        var service = {
            addNotificationList: addNotificationList
        };
        return service;

        function addNotificationList(id, name, comment, listType, items) {
            service.loading = true;

            var containerDefinition = { id: id, name: name, comment: comment, listType: listType};

            var containerModel = { containerDefinition: containerDefinition, items: items }

            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/NotificationLists/NotificationList';
            $http({
                url: url,
                method: 'PUT',
                data: JSON.stringify(containerModel),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.loading = false;
                deferred.resolve(response.data);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }



    }
})();